<script>
	import { user } from './stores.js';
	export let big = false;

	function mapClick() {
		big = !big;
	}
</script>

<style>
	img {
		display: block;
		max-width: 100%;
		max-height: 100%;
		background: #FFF;
	}

	.map {
		/*background: #FAF;*/
		/*border: ;*/
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		width: 150px;
		/*height: 150px;*/
	}

	.full-map {
		text-align: center;
		/*display: flex;*/
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.full-map.big {
		display: block;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		padding: 70px;
		z-index: 10;
		background: rgba(0, 0, 0, 0.8);
	}
	.full-map:not(.big) {
		display: none;
	}

	.close {
		display: inline-block;
		margin: 20px;
		width: 200px;
		height: 100px;
		line-height: 100px;
		text-align: center;
		background: #FFF;
		font-weight: 600;
		font-size: 25px;

		/*padding: 20px 100px;*/
		background: #ec6a33;
		color: #FFF;
		border-radius: 6px;
		/*position: absolute;
		top: 10px;
		right: 10px;*/
	}
</style>

<div class="full-map" class:big on:click={mapClick}>
	<img src="/kartta.png">
	<div>
		<div class="close">Close</div>
	</div>
</div>

<div class="map" class:big on:click={mapClick}>
	<img src="/kartta.png">
</div>
